import developerApi from '@/api/v1/developer';

export default {
  namespaced: true,

  state: {
    survey: [],
    isDataLoading: false,
    answers: [],
  },

  mutations: {
    CHANGE_SURVEY_DATA(state, surveyData) {
      state.survey = { ...surveyData };
    },
    CHANGE_LOADING_STATUS(state, status) {
      state.isDataLoading = status;
    },
    CHANGE_ANSWERS(state, answersPartial) {
      state.answers = state.answers.concat(answersPartial);
    },
  },

  actions: {
    fetchSurvey({ commit }) {
      commit('CHANGE_LOADING_STATUS', true);

      return new Promise((resolve, reject) => {
        developerApi.survey
          .index()
          .then((resp) => {
            commit('CHANGE_SURVEY_DATA', resp.data);
            resolve();
          })
          .catch(() => {
            reject();
          })
          .finally(() => {
            commit('CHANGE_LOADING_STATUS', false);
          });
      });
    },

    addAnswers({ commit }, answersPartial) {
      commit('CHANGE_ANSWERS', answersPartial);
    },

    submitSurvey({ state, dispatch }, token) {
      return new Promise((resolve, reject) => {
        developerApi.accounts
          .softSkills(token, {
            answers: state.answers,
            sensitive_data_accepted: true,
          })
          .then(() => {
            dispatch('showSuccess', ['Survey submitted'], { root: true });
            resolve();
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          });
      });
    },
  },
};
